import { render, staticRenderFns } from "./VideoType.vue?vue&type=template&id=95b8c644&scoped=true&"
import script from "./VideoType.vue?vue&type=script&lang=js&"
export * from "./VideoType.vue?vue&type=script&lang=js&"
import style0 from "../../css/video.css?vue&type=style&index=0&id=95b8c644&scoped=true&lang=css&"
import style1 from "./VideoType.vue?vue&type=style&index=1&id=95b8c644&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95b8c644",
  null
  
)

export default component.exports